import {PropTypes} from 'prop-types';
import {SvgIcon} from '@shipwell/shipwell-ui';
import moment from 'moment';
import {ActionStepLabel} from 'App/containers/WorkflowSummaryCard/ActionStepLabel';

export const WorkflowTooltip = ({query, name, status, endDate, currentStep, startTime}) => {
  const statusTheme = () => {
    switch (status) {
      case 'FAILED':
        return {
          color: 'sw-error',
          icon: 'ErrorFilled',
          label: 'Failed'
        };
      case 'RUNNING':
        return {
          color: 'sw-primary',
          icon: 'Running',
          label: 'Running'
        };
      case 'SUCCESS':
        return {
          color: 'sw-success',
          icon: 'CheckCircleFilled',
          label: 'Complete'
        };
      case 'CANCELLED':
        return {
          color: 'sw-icon',
          icon: 'Cancel',
          label: 'Cancelled'
        };
      default:
        return {
          color: 'sw-primary',
          icon: 'Running',
          label: '--'
        };
    }
  };

  const {color, icon, label} = statusTheme();

  const isRunning = status === 'RUNNING';
  const iconContainerBackgroundColor = isRunning ? color : 'sw-background-component';
  const iconContainerBorder = isRunning ? 'border-white border-2' : '';
  const iconTextColor = isRunning ? 'sw-background-component' : color;
  const stepNumber = currentStep?.replace(/\D/g, '');

  return (
    <div className="flex items-center gap-2">
      <div className={`bg-${iconContainerBackgroundColor} rounded-full ${iconContainerBorder}`}>
        <SvgIcon className={`text-${iconTextColor}`} name={icon} />
      </div>
      <div className="flex flex-col gap-1">
        <span className="font-bold">
          {name} ({label})
        </span>
        {query.isInitialLoading ? <SvgIcon name="LoadingDots" /> : null}
        {isRunning && query.isSuccess ? (
          <span>
            On Step {stepNumber}:{' '}
            {query.isInitialLoading ? <SvgIcon className="inline-block" name="LoadingDots" /> : null}
            {query.isSuccess ? (
              <ActionStepLabel action={query.data} id={query.data?.action_id} startTime={startTime} />
            ) : null}
          </span>
        ) : endDate ? (
          <span>
            {label} {moment(endDate).format('MM/DD/YYYY h:mm a')}
          </span>
        ) : null}
      </div>
    </div>
  );
};

WorkflowTooltip.propTypes = {
  name: PropTypes.string,
  status: PropTypes.string,
  endDate: PropTypes.string,
  currentStep: PropTypes.string,
  query: PropTypes.object,
  startTime: PropTypes.string
};
